import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import vAdminformat from '../../adminFormat';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function UpdateBussinessFile({ username, onBussinessFileID, onClose, getBussinessLibrary }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");

    let user2;
    try {
        user2 = JSON.parse(username);
    } catch (e) {
        user2 = username;
    }

    const [formData, setFormData] = useState({
        name: '',
        user_transaction: user2,
        id: ''
    });

    useEffect(() => {
        const getBussinessFile = async () => {
            try {
                const response = await axios.get(`${server_backend}/files/private/select?id=${onBussinessFileID}`, headers);

                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT[0];
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        name: data.name,
                        comment: data.comment,
                        user_transaction: username,
                        est_id: data.est_ID,
                        id: onBussinessFileID
                    });
                }
            } catch (error) {
                console.log(error);
            }
        };
        getBussinessFile();
    }, [onBussinessFileID, username]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${server_backend}/files/private/update`, formData, headers);
            if (response.data.RES_CODE === "00") {
                console.log(formData);
                console.log(response.data)
                Swal.fire({
                    icon: 'success',
                    title: 'Updated Successfully',
                    showConfirmButton: false,
                    timer: 1000
                });
                onClose()
                getBussinessLibrary()
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'There is already a file with the same name, please try with another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal fade bs-example-modal-xl show azoomOutDown" tabIndex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-modal="true" style={{ display: "block", backgroundColor: "#0101019e" }}>
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="myExtraLargeModalLabel">Modify BussinessFile</h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="tab-pane fade show active" id="pills-bill-info" role="tabpanel" aria-labelledby="pills-bill-info-tab">
                            <div className="live-preview">
                                <form onSubmit={handleUpdate}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label htmlFor="name" className="form-label">New file name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter your name"
                                                    id="name"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {/* User Info */}
                                        <h4 className='p-4'>Other Information</h4>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Date Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="user_transaction"
                                                    value={vAdminformat.FormatDate(dateCreated)}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Created</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={userCreated}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">Date Modified</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={dateModify && vAdminformat.FormatDate(dateModify)}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="mb-3">
                                                <label htmlFor="user_transaction" className="form-label">User Modified</label>
                                                <input
                                                    type="text"
                                                    className="form-control"

                                                    id="user_transaction"
                                                    value={userModify}
                                                    name="user_transaction"
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        <div className="card-header align-items-center d-flex">
                                            <div className="col-md-12">
                                                <div className="text-end">
                                                    <button className='btn btn-danger' style={{ marginRight: "5px" }} onClick={onClose}>
                                                        Discard changes
                                                    </button>
                                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                                        {loading ? 'Loading...' : 'Submit'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UpdateBussinessFile;
